<style lang="scss">
@keyframes navAuthorizer {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
}

.Authorizer {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: stretch;
  box-sizing: border-box;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  max-width: 500px;
  max-height: 700px;
  padding: 1.5rem;
  font-size: 1.5rem;
  animation: navAuthorizer .375s ease-in-out .125s 1 normal both;

  a {cursor: pointer}

  .AuthorizerForm {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: space-between;
    &__fieldset {
      flex: 1 0 160px;
      // outline: 1px solid whitesmoke;
      display: flex;
      flex-flow: column nowrap;
      align-items: stretch;
      justify-content: center;
    }

    &__submit {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-end;
      justify-content: space-between;
      margin: 1.5rem 0 0;
      .button {
        flex: 0 1 8em;
        margin-left: auto;
        padding: 0 1em;
      }
    }

    &__bottom {
      text-align: center;
      margin: 2rem 0 0;
      p {
        margin: 0;
      }
    }
  }

  &__back {
    margin: 0 0 2rem;
    height: 2rem;
    button {
      border: 0;
      margin: 0;
      padding: 0;
      font: inherit;
      font-size: 100%;
      cursor: pointer;
      background: none;
      .icon {
        width: 38px;
        height: 30px;
        margin: 0 .75rem 0 0;
        vertical-align: bottom;
      }
      span {
        display: inline-block;
        vertical-align: bottom;
      }
      &:hover {
        color: $accent;
      }
    }
  }

  &__head {
    h3 {
      margin: 0;
      // font-size: 266.66%;
      font-size: 250%;
      font-weight: 500;
      b {
        font-weight: inherit;
        color: $accent;
      }
    }

    p {
      margin: .75em 0 0;
    }
  }

  &__form {
    margin: 2rem 0 0;
    flex: 1 0 auto;
    .input-text {
      width: 100%;
      display: flex;
      font-size: 1.125rem;
    }
    .input-text + .input-text {
      margin-top: 2rem;
    }
  }
}
</style>

<template>
<div class="Authorizer" :key="authAction">
  <!-- <button @click.prevent="token">Token</button>
  <button @click.prevent="email">Email</button>
  <button @click.prevent="signup">Signup</button> -->

  <div class="Authorizer__back">
    <button v-if="authAction==='reset'" @click="authAction = AuthAction.login">
      <icon-svg symbol="arrow-left"/>
      <span>Back</span>
    </button>
    <button v-if="authAction==='verify'" @click="authAction = AuthAction.reset">
      <icon-svg symbol="arrow-left"/>
      <span>Change email</span>
    </button>
  </div>

  <div class="Authorizer__head">
    <h3>
      <span v-if="authAction === AuthAction.reset">Reset password</span>
      <span v-else-if="authAction === AuthAction.signup">Sign up</span>
      <span v-else-if="authAction === AuthAction.verify">Verify your <b>identity</b></span>
      <span v-else-if="authAction === AuthAction.change">Change password</span>
      <span v-else>Login</span>
    </h3>

    <p v-if="authAction === AuthAction.reset">
      Enter your email or phone number and we will send you a verification code
    </p>
    <p v-else-if="authAction === AuthAction.signup">
      By creating an account you agree with
      our&nbsp;<router-link :to="{name: 'home'}">Tems of Service</router-link>
      and&nbsp;<router-link :to="{name: 'home'}">Privacy Policy</router-link>
    </p>
    <p v-else-if="authAction === AuthAction.verify">
      We have sent you a message with 6-digit code,
      or use the code from yout Authenticator App.
    </p>
    <p v-else-if="authAction === AuthAction.change">
      Create a new password mixing numbers, symbols,
      upper and lower case letters.
    </p>

  </div>

  <div class="Authorizer__form">
      <FormReset v-if="authAction === AuthAction.reset" v-model="loginValue" />
      <FormChange v-else-if="authAction === AuthAction.change"/>
      <FormVerify v-else-if="authAction === AuthAction.verify" v-model="loginValue"/>
      <FormLogin v-else
        :signup="authAction === AuthAction.signup"
        @clickForgotten="authAction = AuthAction.reset"
        v-model="loginValue"/>
  </div>

</div>
</template>

<script>
import FormLogin from './login.vue';
import FormReset from './reset.vue';
import FormChange from './change.vue';
import FormVerify from './verify.vue';

export const AuthAction = {
  signup: 'signup',
  login: 'login',
  reset: 'reset',
  change: 'change',
  verify: 'verify',
};

export default {
  name: 'Authorizer',
  components: {
    FormLogin,
    FormReset,
    FormChange,
    FormVerify,
  },
  data() {
    return {
      AuthAction: AuthAction,
      authAction: AuthAction.login,
      loginValue: '',
    };
  },
}
</script>
